  <!-- Modal -->
  <div class="modal fade" id="mdlEmailTemplate" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <form (ngSubmit)="onSaveTemplate()" #emailTemplateForm="ngForm" *ngIf="currentViewMode == 'edit'">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">ID: {{selectedData?.id}} </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- input fields -->
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Title: </label>
                  <input type="text" required name="Title" [(ngModel)]="currentTemplate.Title" class="form-control" placeholder="Input a title for template">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Code: </label>
                  <input type="text" required name="Code" [(ngModel)]="currentTemplate.Code" class="form-control" placeholder="Input a code for template">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Short Description: </label>
                  <textarea name="ShortDescription" [(ngModel)]="currentTemplate.ShortDescription" class="form-control"></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Email Template: </label>
                  <ckeditor #emailContent name="Content" (change)="onTemplateChange()" [(ngModel)]="currentTemplate.Content" [config]="CkeditorConfig"></ckeditor>
                </div>
              </div>
            </div>
          <!-- end input fields-->
        </div>
        <div class="modal-footer">
          <button type="button" [disabled]="!isSaved" class="btn btn-sucess" (click)="onViewMode('preview')">Preview</button>
          <button type="button" #closeTemplateModalBtn class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="submit" [disabled]="!emailTemplateForm.valid" class="btn btn-primary">
            <span *ngIf="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Save changes
          </button>
        </div>
      </form>
      <app-emailPreview *ngIf="selectedData && currentViewMode=='preview'" (viewMode)="onViewMode($event)" [currentConfigurationId]="emailConfigSelected.value.id" [currentApiKey]="currentApiKey" [currentTemplateId]="selectedData.id"></app-emailPreview>
      </div>
    </div>
  </div>
  